import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';

function SurveyNoQuestions({ t }) {
  return (
    <div className="course-quiz-wrapper">
      <div className="m-portlet m-portlet--rounded">
        <div className="m-portlet__body">
          <div className="quiz-question-container">
            <div className="quiz-question-question">
              {t('survey_noQuestions')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SurveyNoQuestions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(SurveyNoQuestions);
